/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import axios from "axios";
import style from './Modal.module.css';
import gstyle from '../../../css/GeneralStyle.module.css';
import Modal from './Modal';
import * as useJwt from '../../../auth/jwt/useJwt.js';
import jwtDefaultConfig from '../../../auth/jwt/jwtDefaultConfig';
import { toast } from 'react-toastify';
import { Button } from 'antd';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import { jaJP } from '@mui/material/locale';

const TableModal = props => {

    const userData = JSON.parse(useJwt.getUserData());
    const theme = useTheme();

    const columns = [
        // {
        //     id: 'sys_table_id',
        //     accessorKey: 'sys_table_id',
        //     enableColumnActions: false,
        //     header: 'ID',
        //     size: 20
        // },
        {
            id: 'table_code',
            accessorKey: 'table_code',
            enableColumnActions: false,
            header: '棚コード',
        },
        {
            id: 'table_row',
            accessorKey: 'table_row',
            enableColumnActions: false,
            header: '棚番号',
            size: 40
        },
        {
            id: 'table_column',
            accessorKey: 'table_column',
            enableColumnActions: false,
            header: '番地',
            size: 40
        },
        {
            id: 'table_floor',
            accessorKey: 'table_floor',
            enableColumnActions: false,
            header: '段',
            size: 40
        },
    ];

    const [loaded, setLoaded] = useState(false);

    const style_label_wrap = [gstyle.cs_label, gstyle.cs_flex_2];
    const style_input_50 = [gstyle.cs_input, gstyle.w50];

    const handleChangeSearchValue = (event) => {
        props.onChange(event.target.value);
    }

    const searchData = (event) => {
        event.preventDefault();
        let data = {};
        data['userID'] = userData['id'];
        data['warehouse_code'] = props.SearchValue2;
        data['weight'] = props.SearchValue3;
        if (props.SearchValue) data['table_code'] = props.SearchValue;

        if (document.getElementById("RotFilterByLike").checked) {
            data['filterByLike'] = 1;
        } else {
            data['filterByLike'] = 0;
        }
        let url = jwtDefaultConfig.backendUrl + jwtDefaultConfig.getMstTableEndpoint;
        setLoaded(true);
        props.setTableData([]);
        axios
            .post(url, data, {
                headers: {
                    Authorization: "Bearer " + useJwt.getToken(),
                },
            })
            .then((response) => {
                setLoaded(false);
                if (response.status == 200) {
                    if (response.data.data.length > 0) {
                        props.setTableData(response.data.data);
                    }
                    if (response.data.data.length == 0) toast.error("検索結果はありません。", { autoClose: 3000 });
                }
            })
            .catch((error) => {
                setLoaded(false);
                toast.error("検索結果はありません。", { autoClose: 3000 });
            });
    }
    const handleChangeData = (data) => {
        props.target(data, props.targetParam != null ? props.targetParam : '');
        props.onClose(true);
    }

    return (
        <Modal title="棚検索" show={props.show} onClose={props.onClose} width={props.width}>
            <div className={gstyle.hyfiled} style={{ justifyContent: 'center' }}>
                <div className={style.cs_tbl} style={{ minHeight: 610 }}>
                    <ThemeProvider theme={createTheme(theme, jaJP)}>
                        <MaterialReactTable
                            columns={columns}
                            data={props.tableData}
                            enableTopToolbar={true}
                            enableSelectAll={false}
                            enableGlobalFilter={true}
                            enableColumnFilters={false}
                            initialState={{
                                showColumnFilters: true,
                                showGlobalFilter: true,
                            }}
                            localization={MRT_Localization_JA}
                            muiTableBodyProps={{
                                sx: {
                                    '& tr:nth-of-type(odd)': {
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #e0e0e0',
                                    },
                                    'td' : {
                                        padding: '0.4rem'
                                    }
                                    },
                            }}
                            muiTableBodyCellProps={{
                                sx: {
                                    border: '1px solid #e0e0e0',
                                    textAlign: 'center'
                                },
                            }}
                            muiTableHeadCellProps={{
                                sx: {
                                    border: '1px solid #e0e0e0',
                                    '.Mui-TableHeadCell-Content': {
                                        display: 'flex',
                                        justifyContent: 'center',

                                    },
                                    backgroundColor: '#cfcfcf'
                                }
                            }}
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    handleChangeData(row.original);
                                },
                                sx: {
                                    cursor: 'pointer',
                                },
                            })}
                            renderTopToolbarCustomActions={({ table }) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label className={style_label_wrap.join(" ")}>
                                        <div className={gstyle.cs_flex}>
                                            <span style={{ width: 90, marginLeft: 20 }}>棚コード</span>
                                            <input type={'text'} className={style_input_50.join(" ")}
                                                value={props.SearchValue} onChange={handleChangeSearchValue} />
                                        </div>
                                    </label>
                                    <Button onClick={searchData} loading={loaded} type={'primary'} style={{ marginLeft: 30, width: 120, height: 35, borderRadius: 'unset' }}>
                                        {loaded ? '検索中' : '検索'}
                                    </Button>
                                    <label className={gstyle.cs_label}>
                                        <div className={gstyle.cs_flex}>
                                            <input type={"checkbox"} className={style.cs_input_check} id="RotFilterByLike" />
                                            <span>部分検索</span>
                                        </div>
                                    </label>
                                </div>
                            )}
                        />
                    </ThemeProvider>
                </div>
            </div>
        </Modal>
    )
}
export default TableModal;




